import { lazy } from 'react';

export const LogoutPage = lazy(() => import('./ui/LogoutPage/LogoutPage'));
